<lib-form-field-container
    [kind]="FormContainerKind.Text"
    [isOptional]="isOptional"
    [matMenu]="colorPaletteMenu"
    (fieldClicked)="FieldClicked($event)">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>

    <ng-content
        suffixText
        select="[suffixText]"></ng-content>
    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            <ng-container *ngTemplateOutlet="previewIcon"></ng-container>
            {{ formControl.value }}
        </div>
    </ng-container>
    <ng-container suffixIcon>
        <lib-icon-button
            [kind]="ButtonKind.FormField"
            [size]="ButtonSize.Large"
            [stopPropagation]="true"
            [icon]="container?.matMenuTrigger?.menuOpen ? Icon.Common.CaretUp : Icon.Common.CaretDown"
            (clicked)="OpenColorPaletteMenu()"></lib-icon-button>
    </ng-container>
    <ng-container prefixIcon>
        <ng-container *ngTemplateOutlet="previewIcon"></ng-container>
    </ng-container>
    <input
        #input
        [id]="formFieldID"
        [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
        [attr.aria-label]="ariaLabel || null"
        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
        [attr.aria-required]="formControl.isRequired"
        [readonly]="true"
        [value]="formControl.value"
        [attr.aria-labelledby]="ariaLabel ? null : formFieldID + '-label'" />
</lib-form-field-container>

<mat-menu
    #colorPaletteMenu="matMenu"
    (closed)="ColorPickerClosed()">
    <div (click)="$event.stopPropagation()">
        <compact-picker
            [control]="compactControl"
            (colorChange)="ColorChangeEvent($event)"
            (mousedown)="MouseDown()"
            (touchstart)="TouchStart()"></compact-picker>
    </div>
    @if (defaultValue !== null) {
        <div
            style="padding-left: 12px; padding-right: 12px"
            class="w-100">
            <lib-button
                [kind]="ButtonKind.Secondary"
                [stretch]="true"
                (clicked)="ResetToDefaultColor()">
                <ng-container
                    label
                    i18n="@@CommonColorPickerDefaultLabel">
                    Reset to Default
                </ng-container>
            </lib-button>
        </div>
    }
</mat-menu>

<ng-template #previewIcon>
           <lib-icon
            [style.padding-right]="'var(--sb_form-field-container_text-field_single-line_input_gap)'"
            [fill]="formControl.value"
            [icon]="Icon.Common.Square"
            [size]="IconSize.Small"></lib-icon>
</ng-template>

<!-- hidden logo  -->
<img
    #logo
    style="display: none"
    [src]="base64Image"
    (load)="GetDominantColors()" />
